import {inject, Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {AuthService} from '../services/auth/auth.service';
import {catchError, Observable, of} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    private authService: AuthService = inject(AuthService);

    constructor() {}

    canActivate(): Observable<boolean> {
        return this.authService.checkIfUserIsAuthenticated().pipe(
            catchError((error) => {
                this.authService.logout();
                return of(false);
            })
        );
    }
}
